import React, { useState } from "react";
import axios from "axios";
import {
    Truck, Loader2, ShieldCheck, ChevronRight, ArrowLeft
} from "lucide-react";
import { toast } from "sonner";
import { useNavigate, Link } from "react-router-dom";

const API = (process.env.REACT_APP_BACKEND_URL || "") + "/api";

const inputStyle = {
    width: '100%', height: '50px', padding: '0 16px',
    background: 'rgba(15,23,42,0.6)', border: '1px solid rgba(255,255,255,0.08)',
    borderRadius: '14px', color: '#fff', fontSize: '14px', fontWeight: '600',
    outline: 'none', boxSizing: 'border-box', transition: 'border-color 0.2s',
    appearance: 'none'
};

const labelStyle = {
    display: 'block', fontSize: '9px', fontWeight: '800',
    color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.15em', marginBottom: '8px'
};

export const DriverRegister = () => {
    const navigate = useNavigate();
    const [loading, setLoading] = useState(false);
    const [formData, setFormData] = useState({
        fullname: "", email: "", phone: "",
        department: "", commune: "", vehicle_type: "motorcycle", password: ""
    });

    const set = (key) => (e) => setFormData({ ...formData, [key]: e.target.value });
    const focusStyle = (e) => { e.target.style.borderColor = 'rgba(255,153,0,0.5)'; };
    const blurStyle = (e) => { e.target.style.borderColor = 'rgba(255,255,255,0.08)'; };

    const handleSubmit = async (e) => {
        e.preventDefault();
        setLoading(true);
        try {
            const response = await axios.post(`${API}/drivers/register`, formData);
            if (response.data.success) {
                toast.success("Kont Chofè ou kreye ak siksè! Kounye a konekte.");
                navigate("/driver/login");
            }
        } catch (error) {
            toast.error(error.response?.data?.detail || "Erè nan kreyasyon kont chofè.");
        } finally {
            setLoading(false);
        }
    };

    return (
        <div
            style={{
                minHeight: '100vh', display: 'flex', flexDirection: 'column',
                alignItems: 'center', justifyContent: 'flex-start',
                padding: '24px 16px 40px',
                background: 'linear-gradient(160deg, #0F172A 0%, #1E293B 50%, #0F172A 100%)',
                fontFamily: "'Inter', sans-serif"
            }}
        >
            {/* Background decorative glow */}
            <div style={{ position: 'fixed', inset: 0, overflow: 'hidden', pointerEvents: 'none', zIndex: 0 }}>
                <div style={{
                    position: 'absolute', top: '-10%', right: '-10%',
                    width: '600px', height: '600px', borderRadius: '50%',
                    background: 'radial-gradient(circle, rgba(255,153,0,0.07) 0%, transparent 70%)'
                }} />
            </div>

            <div style={{ width: '100%', maxWidth: '520px', position: 'relative', zIndex: 1 }}>
                {/* Logo */}
                <div style={{ textAlign: 'center', marginBottom: '24px' }}>
                    <div style={{
                        width: '70px', height: '70px',
                        background: 'linear-gradient(135deg, #FF9900, #e68a00)',
                        borderRadius: '22px', display: 'flex',
                        alignItems: 'center', justifyContent: 'center',
                        margin: '0 auto 14px',
                        boxShadow: '0 16px 40px rgba(255,153,0,0.35)'
                    }}>
                        <Truck style={{ width: '32px', height: '32px', color: '#000' }} />
                    </div>
                    <h1 style={{
                        fontSize: '26px', fontWeight: '900', color: '#fff',
                        letterSpacing: '-1px', fontStyle: 'italic',
                        textTransform: 'uppercase', lineHeight: 1, marginBottom: '4px'
                    }}>
                        BVG<span style={{ color: '#FF9900' }}>LINK</span>
                    </h1>
                    <p style={{ fontSize: '9px', fontWeight: '800', color: '#64748b', textTransform: 'uppercase', letterSpacing: '0.2em' }}>
                        Kreye Kont Chofè w
                    </p>
                </div>

                {/* Form Card */}
                <div style={{
                    background: 'rgba(30,41,59,0.8)', backdropFilter: 'blur(20px)',
                    borderRadius: '28px', border: '1px solid rgba(255,255,255,0.06)',
                    padding: '28px 20px', boxShadow: '0 40px 80px rgba(0,0,0,0.4)'
                }}>
                    <h2 style={{ fontSize: '13px', fontWeight: '900', color: '#fff', textTransform: 'uppercase', letterSpacing: '0.1em', marginBottom: '4px' }}>
                        Ranpli fòm nan
                    </h2>
                    <p style={{ fontSize: '11px', color: '#64748b', fontStyle: 'italic', marginBottom: '22px' }}>
                        Kòmanse resevwa kòmand livrezon demen menm.
                    </p>

                    <form onSubmit={handleSubmit}>
                        {/* 2-col grid on wider screens, 1-col on mobile */}
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: 'repeat(auto-fill, minmax(200px, 1fr))',
                            gap: '14px',
                            marginBottom: '14px'
                        }}>
                            {/* Non Konplè */}
                            <div>
                                <label style={labelStyle}>Non Konplè</label>
                                <input
                                    placeholder="Jean Robert"
                                    value={formData.fullname}
                                    onChange={set('fullname')}
                                    required
                                    style={inputStyle}
                                    onFocus={focusStyle} onBlur={blurStyle}
                                />
                            </div>

                            {/* Telefòn */}
                            <div>
                                <label style={labelStyle}>Nimewo Telefòn</label>
                                <input
                                    placeholder="+509 3XXX XXXX"
                                    value={formData.phone}
                                    onChange={set('phone')}
                                    required
                                    style={inputStyle}
                                    onFocus={focusStyle} onBlur={blurStyle}
                                />
                            </div>

                            {/* Email */}
                            <div>
                                <label style={labelStyle}>Imèl</label>
                                <input
                                    type="email"
                                    placeholder="chofe@egzanp.com"
                                    value={formData.email}
                                    onChange={set('email')}
                                    required
                                    style={inputStyle}
                                    onFocus={focusStyle} onBlur={blurStyle}
                                />
                            </div>

                            {/* Depatman */}
                            <div>
                                <label style={labelStyle}>Depatman</label>
                                <input
                                    placeholder="Lwès"
                                    value={formData.department}
                                    onChange={set('department')}
                                    required
                                    style={inputStyle}
                                    onFocus={focusStyle} onBlur={blurStyle}
                                />
                            </div>

                            {/* Komin */}
                            <div>
                                <label style={labelStyle}>Komin</label>
                                <input
                                    placeholder="Delmas"
                                    value={formData.commune}
                                    onChange={set('commune')}
                                    required
                                    style={inputStyle}
                                    onFocus={focusStyle} onBlur={blurStyle}
                                />
                            </div>

                            {/* Tip Veyikil */}
                            <div>
                                <label style={labelStyle}>Tip Veyikil</label>
                                <select
                                    value={formData.vehicle_type}
                                    onChange={set('vehicle_type')}
                                    style={{
                                        ...inputStyle,
                                        paddingLeft: '16px',
                                        cursor: 'pointer'
                                    }}
                                    onFocus={focusStyle} onBlur={blurStyle}
                                >
                                    <option value="motorcycle">🏍️  Moto</option>
                                    <option value="car">🚗  Machin</option>
                                    <option value="truck">🚛  Kamyon</option>
                                </select>
                            </div>

                            {/* Modpas - full width */}
                            <div style={{ gridColumn: '1 / -1' }}>
                                <label style={labelStyle}>Modpas Sekirite</label>
                                <input
                                    type="password"
                                    placeholder="••••••••"
                                    value={formData.password}
                                    onChange={set('password')}
                                    required
                                    style={inputStyle}
                                    onFocus={focusStyle} onBlur={blurStyle}
                                />
                            </div>
                        </div>

                        {/* Submit */}
                        <button
                            type="submit"
                            disabled={loading}
                            style={{
                                width: '100%', height: '52px', marginTop: '8px',
                                background: loading ? '#334155' : 'linear-gradient(135deg, #FF9900, #e68a00)',
                                border: 'none', borderRadius: '16px',
                                color: loading ? '#64748b' : '#000',
                                fontSize: '12px', fontWeight: '900',
                                textTransform: 'uppercase', letterSpacing: '0.1em',
                                cursor: loading ? 'not-allowed' : 'pointer',
                                display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px',
                                boxShadow: loading ? 'none' : '0 8px 30px rgba(255,153,0,0.3)',
                                transition: 'all 0.2s'
                            }}
                        >
                            {loading
                                ? <Loader2 style={{ width: '20px', height: '20px', animation: 'spin 1s linear infinite' }} />
                                : "KREYE KONT YO KOUNYE A"
                            }
                        </button>
                    </form>

                    {/* Divider */}
                    <div style={{ display: 'flex', alignItems: 'center', gap: '12px', margin: '20px 0', opacity: 0.3 }}>
                        <div style={{ flex: 1, height: '1px', background: '#fff' }} />
                        <span style={{ fontSize: '9px', fontWeight: '800', color: '#fff', textTransform: 'uppercase' }}>oswa</span>
                        <div style={{ flex: 1, height: '1px', background: '#fff' }} />
                    </div>

                    {/* Login link */}
                    <Link to="/driver/login" style={{ textDecoration: 'none' }}>
                        <button style={{
                            width: '100%', height: '46px',
                            background: 'transparent', border: '1px solid rgba(255,153,0,0.3)',
                            borderRadius: '14px', color: '#FF9900',
                            fontSize: '10px', fontWeight: '900', textTransform: 'uppercase',
                            letterSpacing: '0.1em', cursor: 'pointer',
                            display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '6px'
                        }}>
                            KONEKTE KOUNYE A <ChevronRight style={{ width: '14px', height: '14px' }} />
                        </button>
                    </Link>
                </div>

                {/* Back */}
                <div style={{ textAlign: 'center', marginTop: '16px' }}>
                    <Link to="/marketplace" style={{
                        display: 'inline-flex', alignItems: 'center', gap: '6px',
                        fontSize: '9px', fontWeight: '800', color: '#475569',
                        textTransform: 'uppercase', letterSpacing: '0.15em', textDecoration: 'none'
                    }}>
                        <ArrowLeft style={{ width: '10px', height: '10px' }} /> Tounen nan Marketplace
                    </Link>
                </div>

                {/* Security badge */}
                <div style={{
                    marginTop: '14px', display: 'flex', alignItems: 'center', gap: '10px',
                    padding: '12px 16px', background: 'rgba(255,153,0,0.08)',
                    borderRadius: '14px', border: '1px solid rgba(255,153,0,0.15)'
                }}>
                    <ShieldCheck style={{ width: '16px', height: '16px', color: '#FF9900', flexShrink: 0 }} />
                    <p style={{
                        fontSize: '9px', fontWeight: '800', color: 'rgba(255,255,255,0.6)',
                        textTransform: 'uppercase', letterSpacing: '0.05em', lineHeight: 1.5
                    }}>
                        Done ou yo sekirize. <span style={{ color: '#FF9900' }}>BVGLink Driver App</span> se yon platfòm pwofesyonèl pou livrezon rapid.
                    </p>
                </div>
            </div>
        </div>
    );
};
